/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-child-element-spacing */
/* eslint-disable max-len */
import * as moment from 'moment';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { checkIfLender } from '../../AppUtil/AppUtil';
import { toastWhenLoanStopOrResume, viewUserDetailsGuarantor } from '../../SweetAlertUtil/util';
import LoanService from '../../Service/LoanService';
import TermsAndConditions from '../Profile/TermsAndConditions';
import BaseDetailGuarantor from './BaseDetailGuarantor';
import Loader from '../Common/Loader';
import DwollaPlaid from '../Common/DwollaPlaid';

const LOAN_STATES = window.AppConfig.LOAN_STATES;

class DetailsGuarantor extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			_isTermsAndConditionsOpen: false,
			_isOtherInfoScreenOpen: false,
			_isPaymentMethodScreenOpen: false,
			_isDwollaPlaidScreenOpen: false,
			_fromAddAccount: false,
			_isResumeScreenOpen: false
		};
	}

	toggleResumeScreen = () => {
		this.setState({
			_isResumeScreenOpen: !this.state._isResumeScreenOpen
		});
	};

	toggleTermsConditionsScreen = () => {
		this.setState({
			_isTermsAndConditionsOpen: !this.state._isTermsAndConditionsOpen
		});
	};

	refreshOnBackFromModified = async () => {
		try {
			this.startLoader();
			await this.props.refreshState();
			this.stopLoader();
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	guarantorAcceptLoanRequest = async payment => {
		// NOSONAR
		try {
			this.startLoader();
			const requestBody = {
				action: 'ACCEPT',
				loan_id: this.props.loanObject.id,
				user_id: this.props.currentUserId
			};
			const wallet_connected = this.props.currentUser.profile.wallet_connected || false;
			if (!wallet_connected) {
				this.redirectToDwollaPlaid();
				return false;
			}

			const response = await LoanService.guarantorRespondsInvite(requestBody);

			await this.props.refreshState();
			this.stopLoader();
			if (!response.status) {
				if (response.data === "Loan can't be approved") {
					this.toastWhenLoanActionFail();
					this.props.closeLoanDetail();
				} else {
					this.toastErrorNoConfirmation(response.data);
				}
			} else {
				this.toastLoanAccepted('Loan Accepted');
			}
		} catch (err) {
			console.log(err);
			this.stopLoader();
			this.toastSomethingWentWrong();
		}
	};

	rejectLoanRequest = async () => {
		try {
			this.startLoader();
			const requestBody = {
				action: 'REJECT',
				loan_id: this.props.loanObject.id,
				user_id: this.props.currentUserId
			};
			const response = await LoanService.guarantorRespondsInvite(requestBody);
			await this.props.refreshState();
			this.stopLoader();
			if (!response.status) {
				if (response.data === "Loan can't be decline") {
					this.toastWhenLoanActionFail();
					this.props.closeLoanDetail();
				} else {
					this.toastSomethingWentWrong();
				}
			} else {
				this.toastLoanAccepted('Loan Rejected');
			}
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	toastOnStopPayment = () => {
		toastWhenLoanStopOrResume(this.handleResumeOrStopPayment);
	};
	toastLoanAccepted = acceptanceMessage => {
		Swal.fire({
			animation: false,
			title: this.props.t('sweetalert_title.congratulations'),
			text: this.props.t(acceptanceMessage),
			icon: 'success',
			confirmButtonText: this.props.t('buttons.continue'),
			customClass: 'otp_message_success'
		});
	};

	returnTypeOfLoan = () => {
		return checkIfLender(this.props.currentUserId, this.props.loanObject) ? 'offer' : 'request';
	};

	toastSomethingWentWrong = () => {
		Swal.fire({
			
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('error_message.something_went_wrong'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};

	toastErrorNoConfirmation = errorMsg => {
		Swal.fire({
		
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			title: this.props.t('sweetalert_title.we_are_sorry'),
			text: this.props.t(errorMsg),
			// icon: 'error',
			customClass: 'otp_message_success',
			imageAlt: 'Custom Image'
		});
	};
	toastOnPastPaymentDate = () => {
		const acceptanceMessage = this.props.t('sweetalert.loan_modified_lender', { name: this.props.loanObject.name });
		Swal.fire({
			animation: false,
			title: this.props.t('sweetalert_title.request_submitted'),
			text: acceptanceMessage,
			icon: 'success',
			confirmButtonText: this.props.t('button.continue'),
			customClass: 'otp_message_success'
		});
	};
	cancelSuccess = () => {
		Swal.fire({
			animation: false,
			title: this.props.t('sweetalert_title.success'),
			text: this.props.t('sweetalert_title.you_have_successfully_canceled_the_loan'),
			icon: 'success',
			customClass: 'otp_message_success'
		});
	};
	genrateButton = (name, action) => {
		return (
			<Grid className="no-shadow" container id="reduce-width" justify="center" key={'key-' + name} spacing={2}>
				<Grid id="shadow-round" item sm={8} xs={12}>
					<Button
						aria-label="add"
						fullWidth
						id={(() => {
							if (name === 'buttons.accept_loan_request') {
								return 'agree-button';
							} else {
								if (name === 'buttons.reject_loan_request') {
									return 'cancel-button';
								} else {
									return 'all-button';
								}
							}
						})()}
						onClick={action}
						type="submit">
						{this.props.t(name)}
					</Button>
				</Grid>
			</Grid>
		);
	};

	toastWhenLoanActionFail = () => {
		Swal.fire({
			
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('sweetalert.your_loan_has_been_canceled'), //tushar .. change msg .. u r no longer involved as G
			// icon: 'error',
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};
	generateAction = () => {
		// NOSONAR
		const loanObject = this.props.loanObject;
		loanObject.installments.sort((a, b) => {
			if (moment(a.installment_date).diff(moment(b.installment_date), 'days') > 0) {
				return 1;
			} else {
				if (moment(b.installment_date).diff(moment(a.installment_date), 'days') > 0) {
					return -1;
				} else {
					return 0;
				}
			}
		});
		if (loanObject.state === LOAN_STATES.PENDING || loanObject.state === LOAN_STATES.APPROVE) {
			if (loanObject.guarantor_action === null) {
				return [
					this.genrateButton('buttons.accept_loan_request', this.guarantorAcceptLoanRequest),
					this.genrateButton('buttons.reject_loan_request', this.rejectLoanRequest)
				];
			} else {
				return [];
			}
		} else if (loanObject.state === LOAN_STATES.APPROVE || loanObject.state === LOAN_STATES.COMPLETED) {
			if (loanObject.guarantor_action === 'ACCEPTED') {
				return [
					this.genrateButton('buttons.generate_loan_documentation', this.props.openLoanAgreement),
					this.genrateButton(
						'buttons.generate_loan_documentation_guarantor_lender',
						this.props.openLoanAgreementLenderGuarantor
					),
					this.genrateButton(
						'buttons.generate_loan_documentation_guarantor_borrower',
						this.props.openLoanAgreementBorrowerGuarantor
					)
				];
			} else if (loanObject.guarantor_action === 'REJECTED') {
				return [];
			}
		}
	};

	addBankAccount = () => {
		const wallet_connected = this.props.currentUser.profile.wallet_connected || false;
		this.setState({
			_fromAddAccount: true
		});
		if (!wallet_connected) {
			this.redirectToDwollaPlaid();
		}
	};

	closeDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
	};

	onBackDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
		this.guarantorAcceptLoanRequest();
	};

	redirectToDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: true
		});
	};

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	toggleOtherInfo = () => {
		this.setState({
			_isOtherInfoScreenOpen: !this.state._isOtherInfoScreenOpen
		});
	};

	onViewDetails = userLendBorrow => {
		let userInfo;
		if (userLendBorrow === 'LENDER') {
			userInfo = this.props.loanObject.lender;
		}
		if (userLendBorrow === 'BORROWER') {
			userInfo = this.props.loanObject.borrower;
		}
		viewUserDetailsGuarantor(userInfo);
	};

	componentDidMount() {
		if (this.props.refreshWhenModifiedClose) {
			this.refreshOnBackFromModified();
		}
		if (this.props.props.match.path === '/amortization-table/:id') {
			this.props.openAmortizationTable();
		}
	}

	render() {
		if (this.state._isDwollaPlaidScreenOpen) {
			return (
				<DwollaPlaid
					currentUser={this.props.currentUser}
					onBack={this.onBackDwollaPlaid}
					onClose={this.closeDwollaPlaid}
					openScreen={this.props.openScreen}
					setCurrentUser={this.props.setCurrentUser}
					supportedStates={this.props.supportedStates}
				/>
			);
		} else if (this.state._isTermsAndConditionsOpen) {
			return (
				<TermsAndConditions
					currentUser={this.props.currentUser.profile}
					handleBack={this.toggleTermsConditionsScreen}
					handleContinue={this.redirectToDwollaPlaid}
				/>
			);
		} else {
			return (
				<>
					<BaseDetailGuarantor
						_isLoading={this.state._isLoading}
						addBankAccount={this.addBankAccount}
						closeLoanDetail={this.props.closeLoanDetail}
						currentUser={this.props.currentUser}
						generateAction={this.generateAction}
						genrateButton={this.genrateButton}
						hashedSupportedStates={this.props.hashedSupportedStates}
						loanObject={this.props.loanObject}
						onClickForName={this.onViewDetails}
						openAmortizationTable={this.props.openAmortizationTable}
					/>
					{this.state._isLoading ? <Loader /> : ''}
				</>
			);
		}
	}
}

export default withTranslation()(DetailsGuarantor);
